import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SkillLogoComponent = _resolveComponent("SkillLogoComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_SkillLogoComponent, {
      name: "TypeScript",
      src: "/img/tech/typescript.png"
    }),
    _createVNode(_component_SkillLogoComponent, {
      name: "Solidity",
      src: "/img/tech/solidity.png"
    }),
    _createVNode(_component_SkillLogoComponent, {
      name: "NestJS",
      src: "/img/tech/nestjs.png"
    }),
    _createVNode(_component_SkillLogoComponent, {
      name: "Koa.js",
      src: "/img/tech/koajs.png"
    }),
    _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
    _createVNode(_component_SkillLogoComponent, {
      name: "Kafka",
      src: "/img/tech/kafka.png"
    }),
    _createVNode(_component_SkillLogoComponent, {
      name: "MongoDB",
      src: "/img/tech/mongo.png"
    }),
    _createVNode(_component_SkillLogoComponent, {
      name: "Elasticsearch",
      src: "/img/tech/elasticsearch.png"
    }),
    _createVNode(_component_SkillLogoComponent, {
      name: "GraphQL",
      src: "/img/tech/graphql.png"
    }),
    _createVNode(_component_SkillLogoComponent, {
      name: "Vue.JS",
      src: "/img/tech/vuejs.png"
    })
  ]))
}